import {Quill} from 'react-quill';

const BlockEmbed = Quill.import('blots/block/embed');

// Choisit dynamiquement le plugin FB à utiliser en fonction de l'URL
const getFacebookPluginSrc = (rawUrl) => {
  const url = (rawUrl || '').trim();
  const lower = url.toLowerCase();

  // Heuristique : URL vidéo
  const isVideo =
    /fb\.watch\//.test(lower) ||            // fb.watch/...
    /\/videos\//.test(lower) ||             // .../videos/123456/...
    /\/video\.php/.test(lower) ||           // .../video.php?v=...
    /\/watch\/?\?v=/.test(lower) ||         // .../watch?v=...
    /\/reel\//.test(lower) ||               // .../reel/...
    /\/reels\//.test(lower) ||              // .../reels/...
    /\/live\//.test(lower);                 // .../live/...

  const encoded = encodeURIComponent(url);

  if (isVideo) {
    // Plugin vidéo classique
    return `https://www.facebook.com/plugins/video.php?href=${encoded}&show_text=false&autoplay=false&mute=false`;
  }

  // Sinon : on considère que c'est un post (posts/, share/, etc.)
  // => embed post complet (comme un tweet)
  return `https://www.facebook.com/plugins/post.php?href=${encoded}&show_text=true`;
};

class FacebookLiveBlot extends BlockEmbed {
  static blotName = 'facebook';
  static className = 'ql-facebook-embed';
  static tagName = 'DIV';

  static create(value) {
    const node = super.create();
    const url = (value?.url || '').trim();
    const mode = (value?.mode || 'contain');      // on garde la notion, même si visuellement neutre
    // défaut = notre 1:0.8 si non fourni
    const aspectW = Number(value?.aspectW ?? 1);
    const aspectH = Number(value?.aspectH ?? 0.8);
 
    // const encoded = encodeURIComponent(url);
    // const src = `https://www.facebook.com/plugins/video.php?href=${encoded}&show_text=false&autoplay=false&mute=false`;
    const src = getFacebookPluginSrc(url);

    const wrapper = document.createElement('div');
    wrapper.className = `ql-facebook-embed-wrapper fit-${mode} h-ratio`;
    // datasets persistés
    wrapper.dataset.mode = mode;
    wrapper.dataset.aspectW = String(aspectW);
    wrapper.dataset.aspectH = String(aspectH);

    // styles inline pour lecture / édition
    wrapper.classList.add('h-ratio');
    wrapper.style.setProperty('--fb-aspect-w', aspectW);
    wrapper.style.setProperty('--fb-aspect-h', aspectH);

    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; web-share');
    iframe.setAttribute('tabindex', '-1'); // évite quelques focus auto agressifs

    wrapper.appendChild(iframe);

    // (optionnel) engrenage existant à droite
    const hit = document.createElement('div');
    hit.className = 'ql-facebook-embed-hit';
    hit.setAttribute('title', 'Options');
    wrapper.appendChild(hit);

    // Nouveau : badge “Options d’affichage” à gauche
    const hint = document.createElement('div');
    hint.className = 'ql-facebook-embed-hint';
    hint.textContent = 'Options d’affichage';
    wrapper.appendChild(hint);

        // Nouveau : poignée de resize (mode "sélection libre")
    const resizer = document.createElement('div');
    resizer.className = 'ql-iframe-resizer';
    // Facultatif : indiquer le mode par défaut
    wrapper.dataset.ratioMode = 'fixed';

    // Icône SVG type Font Awesome à l'intérieur
    resizer.innerHTML = `
      <svg class="ql-iframe-resizer-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
        <path d="M168 32L24 32C10.7 32 0 42.7 0 56L0 200c0 9.7 5.8 18.5 14.8 22.2S34.1 223.8 41 217l40-40 79 79-79 79-40-40c-6.9-6.9-17.2-8.9-26.2-5.2S0 302.3 0 312L0 456c0 13.3 10.7 24 24 24l144 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2S270.3 480 280 480l144 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2S448 209.7 448 200l0-144c0-13.3-10.7-24-24-24L280 32c-9.7 0-18.5 5.8-22.2 14.8S256.2 66.1 263 73l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S177.7 32 168 32z"/>
      </svg>
    `;
    wrapper.appendChild(resizer);

    node.appendChild(wrapper);
    node.setAttribute('contenteditable', 'false');

    return node;
  }

  static value(node) {
    const wrapper = node.querySelector('.ql-facebook-embed-wrapper');
    const iframe = node.querySelector('iframe');
    const src = iframe?.getAttribute('src') || '';
    const m = src.match(/href=([^&]+)/);
    const url = m ? decodeURIComponent(m[1]) : '';

    const mode = wrapper?.dataset?.mode || 'contain';
    const containWidthPct = Number(wrapper?.dataset?.containWidthPct ?? 100); // ignoré visuellement, mais conservé

    const aspectW = Number(wrapper?.dataset?.aspectW ?? 16);
    const aspectH = Number(wrapper?.dataset?.aspectH ?? 9);
   
    return { url, mode, containWidthPct, heightMode: 'ratio', aspectW, aspectH };
   
  }

}


Quill.register(FacebookLiveBlot)

export default FacebookLiveBlot